import React, { memo, useCallback, useEffect, useRef, useState } from "react";

import { Icon } from "@ospweb/sdk-ui";
import { copyText } from "utils";
import log from "logbeacon";

interface KeyStatItemProps {
  label: string;
  value: string | React.ReactNode;
  isCopy?: boolean;
  copyValue?: string;
}

const KeyStatItem: React.FC<KeyStatItemProps> = ({
  label,
  value,
  isCopy,
  copyValue,
}) => {
  const [btnName, setBtnName] = useState("copy");
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const handleCopyValue = useCallback(async () => {
    if (!copyValue) {
      return;
    }
    try {
      await copyText(copyValue);
      setBtnName("check");
      // 清理之前的定时器
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      // 保存新的定时器引用
      timerRef.current = setTimeout(() => {
        setBtnName("copy");
      }, 3000);
    } catch (error) {
      log.error("[文案]Failed to copy:", error);
    }
  }, [copyValue]);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [copyValue]);

  const textValue = typeof value === "string" ? value : "--";

  return (
    <div>
      <h3
        aria-label="Key Stat Item h3"
        data-openreplay-label="Key Stat Item h3 Semantic"
        id="sem-key-stat-item-h3"
        className="body_s text-content_tertiary mb-1"
      >
        {label}
      </h3>
      <div className="body_medium_m text-content_primary flex items-center">
        <span>{value || "--"}</span>
        {isCopy && textValue !== "--" && copyValue && (
          <Icon
            data-openreplay-label={btnName}
            name={btnName}
            onClick={() => handleCopyValue()}
            size={16}
            className="hover:cursor-pointer text-black md:text-white/50 p-[2.5px]"
          />
        )}
      </div>
    </div>
  );
};

export default memo(KeyStatItem);
